import { RelationshipStatus } from "./model";
import * as serviceModel from "../service";
import { isAutoApproval } from "../approval-method/selectors";
import { toDate } from "../time";
import * as approvalMethodModel from "../approval-method";
export function id(relationship) {
  return relationship.id;
}
export function isSample(relationship) {
  return relationship.isSample;
}
export function isVendorCoveringCCFee(relationship) {
  return relationship.feeControls.coverCreditCardFees;
}
export function updatedIsVendorCoveringCCFee(relationship) {
  var _relationship$changes;

  return (_relationship$changes = relationship.changes) === null || _relationship$changes === void 0 ? void 0 : _relationship$changes.coverCreditCardFees;
}
export function updatedIsVendorCoveringCCFeeValue(relationship) {
  var _updatedIsVendorCover;

  return (_updatedIsVendorCover = updatedIsVendorCoveringCCFee(relationship)) === null || _updatedIsVendorCover === void 0 ? void 0 : _updatedIsVendorCover.value;
}
export function updatedIsVendorCoveringCCFeeAutoApprovalDate(relationship) {
  const updated = updatedIsVendorCoveringCCFee(relationship);
  return updated ? approvalMethodModel.autoApprovalDate(updated.approvalMethod) : null;
}
export function actualIsVendorCoveringCCFee(relationship) {
  var _updatedIsVendorCover2;

  return (_updatedIsVendorCover2 = updatedIsVendorCoveringCCFeeValue(relationship)) !== null && _updatedIsVendorCover2 !== void 0 ? _updatedIsVendorCover2 : isVendorCoveringCCFee(relationship);
}
export function vendor(relationship) {
  return relationship.vendor.id;
}
export function customer(relationship) {
  return relationship.customer.id;
}
export function services(relationship) {
  return relationship.services;
}
export function effectiveDate(relationship) {
  const effectiveDate = relationship.effectiveDate;
  return effectiveDate != null ? new Date("".concat(effectiveDate.year, "-").concat(effectiveDate.month, "-").concat(effectiveDate.day)) : null;
}
export function updatedNetTerms(relationship) {
  var _relationship$changes2;

  return (_relationship$changes2 = relationship.changes) === null || _relationship$changes2 === void 0 ? void 0 : _relationship$changes2.netTerms;
}
export function updatedNetTermsAutoApprovalDate(relationship) {
  const updated = updatedNetTerms(relationship);
  return updated ? approvalMethodModel.autoApprovalDate(updated.approvalMethod) : null;
}
export function updatedNetTermsValue(relationship) {
  var _updatedNetTerms;

  return (_updatedNetTerms = updatedNetTerms(relationship)) === null || _updatedNetTerms === void 0 ? void 0 : _updatedNetTerms.value;
}
/** The actual netTerms are the current netTerms, or the netTerms that are awaiting client approval following an amendment. */

export function actualNetTerms(relationship) {
  const updatedNetTerms = updatedNetTermsValue(relationship);
  return updatedNetTerms != null ? updatedNetTerms : relationship.netTerms;
}
export function updatedAmendmentsApprovalMethod(relationship) {
  var _relationship$changes3;

  return (_relationship$changes3 = relationship.changes) === null || _relationship$changes3 === void 0 ? void 0 : _relationship$changes3.amendmentsApprovalMethod;
}
export function updatedAmendmentsApprovalMethodValue(relationship) {
  var _updatedAmendmentsApp;

  return (_updatedAmendmentsApp = updatedAmendmentsApprovalMethod(relationship)) === null || _updatedAmendmentsApp === void 0 ? void 0 : _updatedAmendmentsApp.value;
}
export function updatedAmendmentsApprovalMethodAutoApprovalDate(relationship) {
  const updated = updatedAmendmentsApprovalMethod(relationship);
  return updated ? approvalMethodModel.autoApprovalDate(updated.approvalMethod) : null;
}
export function actualAmendmentsApprovalMethod(relationship) {
  const updatedAmendmentsApprovalMethod = updatedAmendmentsApprovalMethodValue(relationship);
  return updatedAmendmentsApprovalMethod != null ? updatedAmendmentsApprovalMethod : relationship.amendmentsApprovalMethod;
}
export function updatedAllowManualPayments(relationship) {
  var _relationship$changes4;

  return (_relationship$changes4 = relationship.changes) === null || _relationship$changes4 === void 0 ? void 0 : _relationship$changes4.allowManualPayments;
}
export function updatedAllowManualPaymentsValue(relationship) {
  var _updatedAllowManualPa;

  return (_updatedAllowManualPa = updatedAllowManualPayments(relationship)) === null || _updatedAllowManualPa === void 0 ? void 0 : _updatedAllowManualPa.value;
}
export function updatedAllowManualPaymentsAutoApprovalDate(relationship) {
  const updated = updatedAllowManualPayments(relationship);
  return updated ? approvalMethodModel.autoApprovalDate(updated.approvalMethod) : null;
}
export function actualAllowManualPayments(relationship) {
  const updated = updatedAllowManualPayments(relationship);
  return updated ? updated.value : relationship.allowManualPayments;
}
export function hasAutoAmendments(relationship) {
  return relationship.services.some(serviceModel.hasAutoAmendments) || !!relationship.changes && Object.values(relationship.changes).some(value => value && isAutoApproval(value.approvalMethod));
}
export function hasAmendments(relationship) {
  return numAmendments(relationship) !== 0;
}
export function numAmendments(relationship) {
  if (!isApproved(relationship)) return 0;
  const {
    changes
  } = relationship;
  const numRelationshipAmendments = changes ? Object.keys(changes).filter(key => changes[key] != null).length : 0;
  return numRelationshipAmendments + relationship.services.filter(s => serviceModel.isAmended(s.status) || serviceModel.isAwaitingApproval(s.status)).length;
}
export function numPendingInvoices(relationship) {
  return relationship.invoiceStatus.numRequiresPaymentApproval + relationship.invoiceStatus.numPaymentActionRequired;
}
export function numPendingCharges(relationship) {
  return relationship.adHocChargeStatus.numAwaitingApproval;
}
export function isCanceled(_ref) {
  let {
    status
  } = _ref;
  return status === RelationshipStatus.Canceled;
}

function fullName(firstName, lastName) {
  return !firstName ? null : !lastName ? firstName : "".concat(firstName, " ").concat(lastName);
}

export function sellerFullName(relationship) {
  const {
    firstName,
    lastName
  } = relationship.seller;
  return fullName(firstName, lastName);
}
export function buyerFullName(relationship) {
  const {
    firstName,
    lastName
  } = relationship.buyer;
  return fullName(firstName, lastName);
}
export function sellerEmail(relationship) {
  return relationship.seller.email;
}
export function sellerID(relationship) {
  return relationship.seller.id;
}
export function buyerEmail(relationship) {
  return relationship.buyer.email;
}
export function isApproved(_ref2) {
  let {
    status
  } = _ref2;
  return status === RelationshipStatus.Approved;
}
export function isTerminated(_ref3) {
  let {
    status
  } = _ref3;
  return status === RelationshipStatus.Terminated;
}
export function isPending(_ref4) {
  let {
    status
  } = _ref4;
  return status === RelationshipStatus.Pending;
}
export function actualServices(relationship, selectedBundleID) {
  var _relationship$service;

  return relationship.serviceBundles ? ((_relationship$service = relationship.serviceBundles.bundles.find(b => b.id === selectedBundleID)) === null || _relationship$service === void 0 ? void 0 : _relationship$service.services) || [] : relationship.services;
}
export const opposingPartyName = (rel, isVendor) => isVendor ? customerName(rel) : vendorName(rel);
export function paymentMethod(relationship) {
  return relationship.paymentMethod;
}
export function paymentMethodType(relationship) {
  return relationship.paymentMethod ? relationship.paymentMethod.type : 'unknown';
}
export function customerName(relationship) {
  return relationship.suggestedCustomerName || relationship.customer.name;
}
export function vendorName(relationship) {
  return relationship.vendor.name;
}
export function vendorID(relationship) {
  return relationship.vendor.id;
}
export function vendorLogoUrl(relationship) {
  return relationship.vendor.logoUrl;
}
export function formatEffectiveDate(relationship) {
  const {
    effectiveDate
  } = relationship;
  return effectiveDate ? toDate(effectiveDate).toLocaleDateString() : 'On acceptance';
}
export function isInvite(relationship) {
  return relationship.approvalFlow === 'invite';
}